import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-realidad-virtual-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-realidad-virtual-svg-icon.component.html',
  styleUrl: './ln-realidad-virtual-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnRealidadVirtualSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#577778';
}
